import { render, staticRenderFns } from "./card-view-loading.vue?vue&type=template&id=5265318a&scoped=true&"
import script from "./card-view-loading.vue?vue&type=script&lang=js&"
export * from "./card-view-loading.vue?vue&type=script&lang=js&"
import style0 from "./card-view-loading.vue?vue&type=style&index=0&id=5265318a&lang=scss&scoped=true&"
import style1 from "./card-view-loading.vue?vue&type=style&index=1&id=5265318a&lang=scss&scoped=true&"
import style2 from "./card-view-loading.vue?vue&type=style&index=2&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5265318a",
  null
  
)

export default component.exports
import {QCard,QItem,QItemSection,QSkeleton,QItemLabel,QSeparator,QCardSection,QCardActions,QAvatar,QBtn} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QCard,QItem,QItemSection,QSkeleton,QItemLabel,QSeparator,QCardSection,QCardActions,QAvatar,QBtn})
